import * as classnames from 'classnames/bind'
import * as React from 'react'
import cardStyles from '../../components/Card/card.scss'
import BasicLayout from '../../layouts/BasicLayout'
import AnchorForScroll from './anchorForScroll'
import styles from './terms-page.scss'


const cx = classnames.bind({ ...styles, ...cardStyles })

class TermsPage extends React.Component {
  public state = {
    qraftTermsActive: true,
    privacyTermsActive: false,
    userTermsActive: false,
    refundActive: false,
  }

  private ref: { [refName: string]: HTMLElement | null } = {
    qraftTerms: null,
    privacyTerms: null,
    userTerms: null,
    refund: null,
    catalogCard: null,
  }

  public scrollToAnchor = (anchorName: string) => {
    const anchorElement = this.ref[anchorName]
    if (anchorElement) {
      anchorElement.scrollIntoView({ behavior: 'smooth' })
    }
    this.setState({
      qraftTermsActive: anchorName === 'qraftTerms' ? true : false,
      privacyTermsActive: anchorName === 'privacyTerms' ? true : false,
      userTermsActive: anchorName === 'userTerms' ? true : false,
      refundActive: anchorName === 'refund' ? true : false,
    })
  }


  public render() {
    return (
      <BasicLayout>

        {/* <!-- Start page title --> */}
        <div className={cx('page-Terms')}>
          <a ref={ref => this.ref.qraftTerms = ref} />
          <div className={cx('page-title', 'bgc--white')}>
            <div className={cx('container')}>
              <h1 className={cx('page-title__title', 'color--black')}>Qraft 條款</h1>
            </div>
          </div>
        </div>
        {/* <!-- End page title --> */}

        <section className={cx('main')}>
          {/* <!-- Start terms main --> */}
          <div className={cx('page-Terms__main')}>
            <div className={cx('container')}>
              <div className={cx('row')}>
                <div className={cx('col-lg-4')}>
                  {/* <!-- If users scroll down, the catalog will be sticked on the screen and located on where it was horizontally, also it is 96px beneath the navbar -->
                  <!-- Add className "active" to link if you get to the section --> */}
                  <ul className={cx('page-Terms__catalog', 'card', 'bgc--black', 'page-Terms__catalog-card')} >
                    <li className={cx('item')}>
                      <p className={cx('title')}>Qraft 使用者條款</p>
                    </li>
                    <li className={cx('item')}>
                      <AnchorForScroll onClick={this.scrollToAnchor} anchor="privacyTerms" className={cx('link', { 'active': this.state.privacyTermsActive })}>隱私權條款</AnchorForScroll>
                    </li>
                    <li className={cx('item')}>
                      <AnchorForScroll onClick={this.scrollToAnchor} anchor="userTerms" className={cx('link', { 'active': this.state.userTermsActive })}>使用者條款</AnchorForScroll>
                    </li>
                    <li className={cx('item')}>
                      <AnchorForScroll onClick={this.scrollToAnchor} anchor="refund" className={cx('link', { 'active': this.state.refundActive })}>退費辦法</AnchorForScroll>
                    </li>
                  </ul>
                </div>
                <div className={cx('col-lg-8')}>
                  <div className={cx('page-Terms__content-section', 'card', 'bgc--white')}>
                    <a ref={ref => this.ref.privacyTerms = ref} />
                    <h2 className={cx('page-Terms__content-title')}>隱私權條款</h2>
                    <h3 className={cx('page-Terms__content-subtitle', 'color--primary')}>隱私權保護政策的適用範圍</h3>
                    <p className={cx('para')}>隱私權保護政策內容，包括本網站如何處理在您使用網站服務時收集到的個人識別資料。隱私權保護政策不適用於本網站以外的相關連結網站，也不適用於非本網站所委託或參與管理的人員。</p>
                    <h3 className={cx('page-Terms__content-subtitle', 'color--primary')}>個人資料的蒐集、處理及利用方式</h3>
                    <p className={cx('para')}>當您造訪本網站或使用本網站所提供之功能服務時，我們將視該服務功能性質，請您提供必要的個人資料，並在該特定目的範圍內處理及利用您的個人資料；非經您書面同意，本網站不會將個人資料用於其他用途。<br />於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為我們增進網站服務的參考依據，此記錄為內部應用，決不對外公佈。</p>
                    <h3 className={cx('page-Terms__content-subtitle', 'color--primary')}>網站對外的相關連結</h3>
                    <p className={cx('para')}>本網站的網頁提供其他網站的網路連結，您也可經由本網站所提供的連結，點選進入其他網站。但該連結網站不適用本網站的隱私權保護政策，您必須參考該連結網站中的隱私權保護政策。</p>
                    <h3 className={cx('page-Terms__content-subtitle', 'color--primary')}>與第三人共用個人資料之政策</h3>
                    <p className={cx('para')}>本網站絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。<br />Qraft 如舉辦任何回饋活動，你所提供給主辦單位的得獎連絡資料，也僅供此活動使用。 Qraft 不會將活動資料直接交付或售予第三方。如果 Qraft 與第三方服務合作，亦應依法要求該第三方 Qraft 的會員網站使用對應的約定及隱私權政策， Qraft 將會盡全力保障所有會員個人資料的安全性。</p>
                    <h3 className={cx('page-Terms__content-subtitle', 'color--primary')}>COOKIE之使用</h3>
                    <p className={cx('para')}>為了提供您最佳的服務，本網站會在您的電腦中放置並取用我們的Cookie，若您不願接受Cookie的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕Cookie的寫入，但可能會導至網站某些功能無法正常執行 。</p>
                  </div>
                  <div className={cx('page-Terms__content-section', 'card', 'bgc--white')}>
                    <a ref={ref => this.ref.userTerms = ref} />
                    <h2 className={cx('page-Terms__content-title')}>使用者條款</h2>
                    <h3 className={cx('page-Terms__content-subtitle', 'color--primary')}>同意條款</h3>
                    <p className={cx('para')}>非常歡迎您使用 Qraft（以下簡稱本服務），為了讓您能夠安心使用本網站的各項服務與資訊，特此向您說明本網站的隱私權保護政策，以保障您的權益，應詳細閱讀本條款所有內容。當您使用本服務時，即表示您已閱讀、了解並同意本條款所有內容。此外，因Qraft提供多種服務，某些服務可能因其特殊之性質而有附加條款，當您開始使用該服務即視為您同意該附加條款或相關規定亦屬本條款之一部份。Qraft 有權於任何時間修改或變更本條款內容，建議您隨時注意該修改或變更。當您於任何修改或變更後繼續使用本服務，視為您已閱讀、了解並同意接受該修改或變更內容。如果使⽤者不同意 Qraft 對本條款進⾏的修改，請離開 Qraft 網站並⽴即停⽌使⽤ Qraft 服務。同時，會員應刪除個⼈檔案並註銷會員資格，Qraft 亦有權刪除會員個⼈檔案並註銷會員資格。請您詳閱下列內容：</p>
                    <h3 className={cx('page-Terms__content-subtitle', 'color--primary')}>註冊義務、帳號密碼及資料保密</h3>
                    <p className={cx('para')}>用戶登錄資料須提供使用者本人正確、最新及完整的資料。<br />用戶登錄資料不得有偽造、不實、冒用等之情事(ex如個人資料及信用卡資料)，一經發現本公司可拒絕其加入用戶資格之權利。並得以暫停或終止其用戶資格，若違反中華民國相關法律，亦將依法追究。<br />用戶應妥善保管密碼，不可將密碼洩露或提供給他人知道或使用；以同一個用戶身分證字號和密碼使用本服務所進行的所有行為，都將被認為是該用戶本人和密碼持有人的行為。<br />若使⽤者本人未滿七歲，要由使⽤者的⽗⺟或法定監護⼈申請加⼊會員。 若使⽤者已滿七歲未滿⼆⼗歲，則必須在申請加⼊會員之前，請⽗⺟或法定監護⼈閱讀本條款，並得到⽗⺟或監護⼈同意後，才可以申請、註冊及使⽤本網站所提供的服務；當使⽤者滿⼆⼗歲之前使⽤本網站服務，則必須向本公司擔保已取得⽗⺟或監護⼈的同意。</p>
                    <h3 className={cx('page-Terms__content-subtitle', 'color--primary')}>使用規定和條約</h3>
                    <p className={cx('para')}>不論註冊與否，會員及一般使用者在使用本公司所提供之服務時，您應遵守相關法律，並同意不得利用本服務從事侵害他人權利或違法行為，此行為包含但不限於：</p>
                    <ol className={cx('page-Terms__content-order-list')}>
                      <li>上載、張貼、公布或傳送任何誹謗、侮辱、具威脅性、攻擊性、不雅、猥褻、不實、違反公共秩序或善良風俗或其他不法之文字、圖片或任何形式的檔案；</li>
                      <li>侵害他人名譽、隱私權、營業秘密、商標權、著作權、專利權、其他智慧財產權及其他權利；</li>
                      <li>違反法律、契約或協議所應負之保密義務；</li>
                      <li>企圖入侵本公司伺服器、資料庫、破解本公司安全機制或其他危害本公司服務提供安全性或穩定性之行為；</li>
                      <li>從事不法交易行為或張貼虛假不實、引人犯罪之訊息；</li>
                      <li>未經本公司明確授權同意並具書面授權同意證明，不得利用本服務或本網站所提供其他資源，包括但不限於圖文、影音資料庫、編寫製作網頁之軟體等，從事任何商業交易行為，或招攬廣告商或贊助人；</li>
                      <li>販賣槍枝、毒品、盜版軟體或其他違禁物；</li>
                      <li>提供賭博資訊或以任何方式引誘他人參與賭博；</li>
                      <li>濫發廣告訊息、垃圾訊息、連鎖信、違法之多層次傳銷訊息等；</li>
                      <li>其他 Qraft 有正當理由認為不適當之行為。</li>
                    </ol>
                    <h3 className={cx('page-Terms__content-subtitle', 'color--primary')}>暫停或終止服務</h3>
                    <p className={cx('para')}>本服務於網站相關軟硬體設備進行更換、升級或維修時，得暫停或中斷本服務。如因維修或不可抗力因素，導致本公司網站服務暫停，暫停的期間造成直接或間接利益之損失，本公司不負損失賠償責任。<br />如果本服務需有或內含可下載軟體，該軟體可能會在提供新版或新功能時，在您的裝置上自動更新。部分情況下可以讓您調整您的自動更新設定。<br />您使用本服務之行為若有任何違反法令或本使用條款或危害本公司或第三者權益之虞時，在法律准許範圍內，於通知或未通知之情形下，，立即暫時或永久終止您使用本服務之授權。此外，使⽤者同意若本服務之使⽤被中斷或終⽌帳號及相 關信息和⽂件被關閉或刪除，Qraft 對使⽤者或任何第三⼈均不承擔任何責任。</p>
                    <h3 className={cx('page-Terms__content-subtitle', 'color--primary')}>舉報</h3>
                    <p className={cx('para')}>倘發現任何違反本服務條款之情事，請通知 Qraft。</p>
                    <h3 className={cx('page-Terms__content-subtitle', 'color--primary')}>聯絡我們</h3>
                    <p className={cx('para')}>如果對本隱私政策或我們的信息處理方法有任何疑問，請通過電子郵件的方式聯繫：contact@qraft.app</p>
                  </div>
                  <div className={cx('page-Terms__content-section', 'card', 'bgc--white')}>
                    <a ref={ref => this.ref.refund = ref} />
                    <h2 className={cx('page-Terms__content-title')}>退費辦法</h2>
                    <h3 className={cx('page-Terms__content-subtitle', 'color--primary')}>退費規定</h3>
                    <p className={cx('para')}>線上講座：講座內容已上架的講座課程，學員於購買後七日內講座，可憑購買序號申請退費。<br />預購講座：標示有「預購」標籤之講座，募資期間購課之學員於預購截止日前皆可憑愈好申請退費，預購截止日後，則不接受退費，於課程內容上架後購課之學員，則依照前述線上講座退費規定辦理。</p>
                    <h3 className={cx('page-Terms__content-subtitle', 'color--primary')}>退費方式</h3>
                    <p className={cx('para')}>匯款退費：如果您購課時採用ATM轉帳或超商付款，則採匯款退費方式。採匯款退費者須負擔手續費30元。<br />退費申請流程: 請您填寫客服意見信箱，將有專人與您聯繫。</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- End terms main --> */}
        </section>

      </BasicLayout>
    )
  }
}

export default TermsPage


// WEBPACK FOOTER //
// ./src/pages/TermsPage/index.tsx